// @ts-nocheck
import {
  Autocomplete,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { memo, useState } from "react";
import { apiRequest } from "../../../../../services/apiService";
import { useCallback } from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { Close } from "@mui/icons-material";

export const CustomAirportInput = memo(
  ({ onChange, value }) => {
    const [inputVal, setInputVal] = useState("");
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchAirports = useCallback(async () => {
      setIsLoading(true);
      const { response } = await apiRequest({
        method: "GET",
        url: "getAirportsBySearch",
        params: { search: inputVal },
        isToken: true,
      });

      setIsLoading(false);
      setOptions(response?.status === 200 ? response?.data?.data : []);
    }, [inputVal]);

    useEffect(() => {
      const delayDebounce = setTimeout(() => {
        fetchAirports();
      }, 300);

      return () => clearTimeout(delayDebounce);
    }, [inputVal, fetchAirports]);

    return (
      <Autocomplete
        fullWidth
        value={value?.airportName ? value : null}
        onChange={(_, newValue) => onChange(newValue)}
        freeSolo={false}
        options={options}
        isOptionEqualToValue={(option, val) => option?._id === val?._id}
        inputValue={inputVal}
        autoHighlight
        onInputChange={(_, newValue) => setInputVal(newValue)}
        ListboxProps={{ className: "custom-scroll-design" }}
        filterOptions={(x) => x}
        sx={{
          "& .MuiAutocomplete-clearIndicator": {
            visibility: value?.airportName ? "visible" : "hidden",
          },
          height: "50px",
          "& button": {
            color: "white",
          },
        }}
        clearIcon={
          <Close
            sx={{
              fontSize: "1rem",
              color: "white",
              background: "grey",
              borderRadius: "50%",
              padding: "0.10rem",
            }}
          />
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Airport"
            InputLabelProps={{ style: { color: "white" } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingY: "7px !important",
                "& fieldset": { borderRadius: "8px", borderColor: "white" },
                "&:hover fieldset, &.Mui-focused fieldset": {
                  borderColor: "white",
                },
                color: "white",
              },
              "& .MuiInputBase-input": { color: "white" },
              "& .MuiAutocomplete-popupIndicator": { color: "white" },
            }}
          />
        )}
        getOptionLabel={(option) =>
          option?.airportName
            ? option?.airportCode
              ? `${option?.airportName} (${option?.airportCode})`
              : option?.airportName
            : ""
        }
        renderOption={(props, option) => (
          <li {...props} key={option._id || option.Id}>
            {option.airportName}{" "}
            {option?.airportCode ? `(${option?.airportCode})` : ""}
          </li>
        )}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              background: "black",
              outline: "1px solid white",
              borderRadius: "8px",
              color: "white",
            }}
          >
            {isLoading ? (
              <Box
                sx={{
                  padding: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CircularProgress size={22} />
              </Box>
            ) : options.length === 0 ? (
              <Box
                sx={{
                  padding: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography>No options</Typography>
              </Box>
            ) : (
              children
            )}
          </Paper>
        )}
      />
    );
  },
  (prevProps, nextProps) => {
    // Only re-render if the airport ID actually changes
    const prevId = prevProps.value?._id || prevProps.value?.Id || prevProps?.onChange;
    const nextId = nextProps.value?._id || nextProps.value?.Id || nextProps?.onChange;

    return prevId === nextId;
  },
);

CustomAirportInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
};

CustomAirportInput.displayName = "CustomAirportInput";